import AvatarMenu from '../User/AvatarMenu';

export default function Layout({ signedOut, children }) {
  return (
    <div className="flex flex-row w-full h-screen overflow-y-hidden">
      <div className="hidden md:flex flex-1 lg:flex-none relative">
        <a href="/" className="absolute top-10 left-10 bg-transparent">
          <img src="/images/lemonaide-logo.png" style={{ height: '30px' }} />
        </a>
        <img
          src="/images/lemonaide-donate-bg.png"
          className="object-cover"
          alt="charity hero image left"
        />
      </div>
      <div className="flex-1">
        <div className="py-6 px-6 sm:py-9 sm:px-9 md:py-12 md:px-18 xl:py-24 xl:px-32 h-screen overflow-y-auto relative">
          <a href="https://www.lemonaide.co/" className="md:hidden">
            <img src="/images/lemonaide-logo.svg" className="h-10" />
          </a>
          {signedOut ? null : (
            <div className="absolute top-5 right-5">
              <AvatarMenu />
            </div>
          )}
          <div className="max-w-4xl my-0 mx-auto">{children}</div>
        </div>
      </div>
    </div>
  );
}
